import { render } from "./inventoryHome.vue?vue&type=template&id=3b362344"
import script from "./inventoryHome.vue?vue&type=script&lang=js"
export * from "./inventoryHome.vue?vue&type=script&lang=js"

import "./inventoryHome.vue?vue&type=style&index=0&id=3b362344&lang=scss"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__